import { useEffect } from 'react';

export function useNav() {
  useEffect(() => {
    const nav = document.getElementById('nav');
    const backTop = document.getElementById('backTop');

    // Nav scroll effect
    const onScroll = () => {
      if (nav) nav.classList.toggle('scrolled', window.scrollY > 40);
      if (backTop) backTop.classList.toggle('visible', window.scrollY > 400);
      updateActive();
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    // Hamburger
    const ham = document.getElementById('hamburger');
    const drawer = document.getElementById('mobileDrawer');
    const onHam = () => {
      ham.classList.toggle('open');
      drawer.classList.toggle('open');
      document.body.style.overflow = drawer.classList.contains('open') ? 'hidden' : '';
    };
    if (ham) ham.addEventListener('click', onHam);
    if (drawer) {
      drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
        ham.classList.remove('open');
        drawer.classList.remove('open');
        document.body.style.overflow = '';
      }));
    }

    // Back to top
    if (backTop) {
      backTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    }

    // Active nav + progress dots
    const sections = ['hero', 'solutions', 'hiw', 'videos', 'industries', 'why', 'testimonials', 'assist'];
    const dots = document.querySelectorAll('.pdot');
    const navAs = document.querySelectorAll('.nav-links a');

    function updateActive() {
      let current = 'hero';
      sections.forEach(id => {
        const el = document.getElementById(id) || document.getElementById(id === 'solutions' ? 'sol1' : id);
        if (el && window.scrollY >= el.offsetTop - 120) current = id;
      });
      dots.forEach((d, i) => d.classList.toggle('active', sections[i] === current));
      navAs.forEach(a => {
        const sec = a.dataset.section || '';
        a.classList.toggle('active', sec === current || (current === 'solutions' && sec === 'sol1'));
      });
    }

    dots.forEach((d, i) => {
      d.addEventListener('click', () => {
        const target = document.getElementById(sections[i]) || document.getElementById('sol1');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });

    // Animation tabs
    const tabs = document.querySelectorAll('.anim-tab');
    const panels = document.querySelectorAll('.anim-panel');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const i = parseInt(tab.dataset.tab);
        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));
        tab.classList.add('active');
        panels[i].classList.add('active');
        setTimeout(() => window.dispatchEvent(new Event('resize')), 30);
      });
    });

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (ham) ham.removeEventListener('click', onHam);
    };
  }, []);
}
